<template>
<div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">

  <div class="text-right leading-tight hidden sm:block">
    <p class="font-semibold">{{ activeUserInfo.fullname }}</p>
    <small>{{ activeUserInfo.organization }}</small>
  </div>

  <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>

    <div class="con-img ml-3">
      <img :src="activeUserInfo.$href('avatar')"
           alt="user-img"
           class="rounded-full shadow-md cursor-pointer block"
           height="40"
           key="onlineImg"
           width="40"/>
    </div>

    <vs-dropdown-menu class="vx-navbar-dropdown">
      <ul style="min-width: 9rem">

        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="profile">
          <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">Profile</span>
        </li>

        <vs-divider class="m-1"/>

        <li @click="logout" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
          <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">Logout</span>
        </li>
      </ul>
    </vs-dropdown-menu>
  </vs-dropdown>
</div>
</template>

<script>

import Amplify from '@aws-amplify/core';
import {halClientOptions} from 'hal-client';

export default {
  computed: {
    activeUserInfo () {
      return this.$store.state.router.profileResource;
    }
  },
  methods: {
    logout () {
      if (this.$store.state.router.profileResource.$hasLink('sso_configuration')) {
        this.$store.state.router.profileResource.$request().$get('sso_configuration').then(ssoConfig => {
          const config = {
            Auth: {
              region: process.env.VUE_APP_COGNITO_REGION,
              userPoolId: process.env.VUE_APP_COGNITO_USER_POOL,
              userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
              oauth: {
                domain: process.env.VUE_APP_COGNITO_IDP_DOMAIN,
                scope: ['email', 'profile', 'openid'],
                redirectSignIn: ssoConfig.redirectSignIn,
                redirectSignOut: ssoConfig.redirectSignOut,
                responseType: 'code'
              }
            }
          };
          Amplify.configure(config);
          halClientOptions.headers.set('Authorization', null);
          this.$store.dispatch('account/removeAccessToken').then(() => {
            this.$router.push({name: 'page-login'});
          });
        });
      } else {
        halClientOptions.headers.set('Authorization', null);
        this.$store.dispatch('account/removeAccessToken').then(() => {
          this.$router.push({name: 'page-login'});
        });
      }
    },
    profile () {
      this.$router.push({name: 'app-profile'});
    }
  }
};
</script>
